import { useState } from "react";
import ButtonComponent from "../../../components/common/button/Button";
import Modal from "../../../components/common/modal/Modal";
import './index.css';

export const SendToNextLevel = ({ singleApproverCount, multiLevelApproverCount,reSubmitCount, disabled, handleSendToNextLevelAPI, setBulkPDTDisabled, setBulkPDTValue }) => {

    const [openModal, setOpenModal] = useState();

    const onCloseLTModal = () => {
        setOpenModal(false)
    }
    const onClickSendToNextLevelButton = () => {
        setOpenModal(true)
    }
    const onClickSubmitButtonAPI = () => {
        onCloseLTModal()
        handleSendToNextLevelAPI()
        setBulkPDTDisabled(true);
        setBulkPDTValue("");
    }

    return (
        <>
            <ButtonComponent
                maxWidth="240px"
                type="secondary"
                label={"Approve & Send to Next Level"}
                onClick={onClickSendToNextLevelButton}
                disabled={disabled}
            />
            <Modal
                className="sendToNextLevelModal_cls"
                open={openModal}
                handleClose={onCloseLTModal}
                title="Confirm"
                action={
                    <SendToNextLevelFooter onClickCancel={onCloseLTModal} onClickSubmit={onClickSubmitButtonAPI} />
                }
                content={
                    <SendToNextLevelContent singleApproverCount={singleApproverCount} multiLevelApproverCount={multiLevelApproverCount} reSubmitCount={reSubmitCount}/>
                }
                maxWidth="500px"
            />
        </>
    )
}

const SendToNextLevelFooter = ({ onClickCancel, onClickSubmit }) => {

    return (
        <div className='sendToNextLevel_footer'>
            <ButtonComponent
                label="Cancel"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
            <ButtonComponent
                label="Submit"
                type="secondary"
                maxWidth="100px"
                onClick={onClickSubmit}
            />
        </div>
    );
};
const SendToNextLevelContent = ({ singleApproverCount, multiLevelApproverCount, reSubmitCount }) => {
    return (

        <div className="sendToNextLevelModalContent_cls">
            <div style={{margin:'10px 0px'}}>
                <div className="selectedItems_cls_approver"><b>Send to S/4 Line Items:</b><p>{singleApproverCount}</p></div>
                <div className="selectedItems_cls_approver"><b>Send to Next Level Line Items:</b><p>{multiLevelApproverCount}</p></div>
                <div className="selectedItems_cls_approver"><b>Resubmit to Next Level Line Items:</b><p>{reSubmitCount}</p></div>
            </div>
            <p>Are you sure you want to proceed with selected line items? </p>
        </div>
    );
};